import Swiper from "swiper";
import { register } from 'swiper/element/bundle';
register();

class SwiperVideos {
  constructor() {

    const swiperVideos = document.querySelectorAll('.swiper--videos');

    let swiperId = '';

    console.log(swiperId);

    swiperVideos.forEach(swipervideo => {

      swiperId = swipervideo.id;

      let breakpointsTemplate = "";

      if (swipervideo.classList.contains("swiper--videos--tile339x192")) {

        breakpointsTemplate = {
          0: {
            spaceBetween: 8,
            slidesPerGroup: 1,
          },
          768: {
            spaceBetween: 12,
            slidesPerGroup: 2,
          },
          810: {
            spaceBetween: 12,
            slidesPerGroup: 3,
          },
          1080: {
            spaceBetween: 12,
            slidesPerGroup: 3,
          },
          1440: {
            spaceBetween: 12,
            slidesPerGroup: 4,
          }
        }
      }

      const swiperVideo = new Swiper(`#${swiperId}`, {
        // Optional parameters
        navigation: {
          nextEl: `.swiper-button-next--${swiperId}`,
          prevEl: `.swiper-button-prev--${swiperId}`,
        },
        slidesPerView: "auto",
        slidesPerGroupAuto: true,
        freeMOde: true,
        slideToClickedSlide: true,
        watchSlidesProgress: true,
        allowTouchMove: true,
        simulateTouch: true,
        breakpoints: breakpointsTemplate,
        observer: true,
        observeParents: true,
        observeSlideChildren: true
      });
    })

    const swiperVideoThumbs = document.querySelectorAll('.videos__thumbs__card');
    const mainVideo = document.querySelector('#ytiframe');
    const mainVideoDefault = document.querySelectorAll('[data-index="1"]');

    if (mainVideo){
      mainVideo.setAttribute('src', 'https://www.youtube.com/embed/' + mainVideoDefault[0].id + '?rel=0');

      mainVideoDefault[0].classList.add('act');
    }

    swiperVideoThumbs.forEach((videoThumb) => {

      videoThumb.addEventListener("click", (e) => {

        const videoThumbId = videoThumb.getAttribute('id');

        mainVideo.setAttribute('src', '');
        mainVideo.setAttribute('src', 'https://www.youtube.com/embed/' + videoThumbId + '?rel=0');

        for (let i = 0; i < swiperVideoThumbs.length; i++) {
          swiperVideoThumbs[i].classList.remove('act');
        }

        e.currentTarget.classList.add('act');

      });
    })
  }
}

export default SwiperVideos